export const ANALYTICS_QA_VET_TICKET_ACTIONS = {
    PIN: "PIN",
    UNPIN: "UNPIN",
    VIEW: "VIEW",
};
